import Proxy from './Proxy';

class EntryProxy extends Proxy
{
    constructor( parameters = {})
    {
        super( 'api/mail', parameters );
    }
}

export default EntryProxy;
